import { DEFAULT_SHARE_HEADER_CONFIG, DEFAULT_OPEN_APP_CONFIG } from './default-config';
import Vue from '_lib/_vue'

export class ShareConfig {
  callbackMap = {
    'share-header': [],
    'open-app': [],
  }

  constructor(initialConfig = {}) {
    const defaultConfig = {
      'share-header': DEFAULT_SHARE_HEADER_CONFIG,
      'open-app': DEFAULT_OPEN_APP_CONFIG,
    }
    // 手动配置项混入默认配置
    Object.keys(initialConfig).forEach(key => {
      const currentConfig = initialConfig[key]
      if (currentConfig && typeof currentConfig === 'object') {
        defaultConfig[key] = { ...defaultConfig[key], ...currentConfig }
      }
    })
    this.shareConfig = Vue.observable(defaultConfig);
  }

  setConfig(key, value) {
    this.callbackMap[key].forEach(callback => {
      callback(value)
    })
    Vue.set(this.shareConfig, key, { ...this.shareConfig[key], ...value });
  }

  getConfig(key) {
    return this.shareConfig[key];
  }

  getCompleteConfig() {
    return { ...this.shareConfig };
  }

  addConfigUpdateCallback(key, callback) {
    this.callbackMap[key].push(callback)
  }

  removeConfigUpdateCallback(key, callback) {
    this.callbackMap[key] = this.callbackMap[key].filter(cb => cb !== callback)
  }

  clearConfigUpdateCallback(key) {
    this.callbackMap[key] = []
  }
}
